import React, { forwardRef } from 'react';
import { Link } from 'gatsby';

import { PromoSlideData } from './models';

const PromoSlide = forwardRef<HTMLElement, PromoSlideData>(
  ({ desktopImage, mobileImage, headline, subHeading, cta, legal }, ref) => {
    const isInternal = cta.link.startsWith('/');

    const renderCta = () =>
      isInternal ? (
        <Link className="hkx-promo__cta" to={cta.link} aria-label={cta.ariaLabel}>
          {cta.label}
        </Link>
      ) : (
        <a
          className="hkx-promo__cta"
          href={cta.link}
          aria-label={cta.ariaLabel}
          rel="noopener noreferrer"
        >
          {cta.label}
        </a>
      );

    return (
      <section ref={ref} className="hkx-promo">
        <picture className="hkx-promo__picture">
          <source media="(max-width: 767px)" srcSet={mobileImage.src} />
          <img
            className="hkx-promo__image"
            src={desktopImage.src}
            alt={desktopImage.altText}
            loading="lazy"
          />
        </picture>

        <div className="hkx-promo__overlay">
          <div className="hkx-promo__headings">
            <h2 className="hkx-promo__headline">{headline}</h2>
            <p className="hkx-promo__subhead">{subHeading}</p>
          </div>
          {renderCta()}
        </div>

        {legal ? <p className="hkx-promo__legal">{legal}</p> : null}
      </section>
    );
  }
);

PromoSlide.displayName = 'PromoSlide';

export default PromoSlide;
